import * as React from 'react';
import styled from 'styled-components';

export interface HandleIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  isDark?: boolean;
}

export const HandleIcon: React.FC<HandleIconProps> = ({
  className,
  isDark,
  ...props
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className || ''}
    {...props}
  >
    <Background
      className={isDark ? 'dark' : ''}
      d="M12,0h0c6.63,0,12,5.37,12,12h0c0,6.63-5.37,12-12,12h0C5.37,24,0,18.63,0,12H0C0,5.37,5.37,0,12,0Z"
    />
    <Line
      className={isDark ? 'dark' : ''}
      fill="none"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth={1.5}
      d="M8,16h8"
    />
    <Line
      className={isDark ? 'dark' : ''}
      fill="none"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth={1.5}
      d="M8,12h8"
    />
    <Line
      className={isDark ? 'dark' : ''}
      fill="none"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth={1.5}
      d="M8,8h8"
    />
  </svg>
);

export default styled(HandleIcon)`
  cursor: grab;
`;

const Background = styled.path`
  fill: ${({ theme }) => theme.colors.secondary};
  &.dark {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;

const Line = styled.path`
  stroke: ${({ theme }) => theme.colors.primary};
  &.dark {
    stroke: ${({ theme }) => theme.colors.differentBackground};
  }
`;
